import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, Row, Table } from "antd"
import Column from "antd/lib/table/Column"
import { baseAxiosNoInfo } from "../../../tool/axios"
import { CheckImgs } from "../../../component/common/Imgs"

interface dataType {
    check_in_user_name: string // 入住人名称
    check_in_phone: string // 入住人手机号
    deal_date: string // 签单日期
    deal_store_name: string // 签单门店名称
    deal_item_name: string // 签单套餐名称
    agreement_code: string // 合同编号
    item_days: string // 入住天数，整数类型
    gift_days: string // 赠送天数，整数类型
    agreement_amount: string // 合同总金额，小数类型
    total_pay_amount: string // 已收金额，小数类型
    total_review_amount: string // 已审核金额，小数类型
    has_one_to_one: string // 是否专人陪护，0没有 1有，整数类型
    remark: string // 备注
    create_time: string // 记录生成时间
    deal_prov_pic_list: string // 签单合同图片集合，英文逗号拼接
    refund_detail: {
        review_status: string // 审核状态，0待审核 1审核通过 2审核不通过，整数类型
        refund_amount: string // 退款金额，小数类型
        refund_reason: string // 退款原因
        refund_date: string // 退款时间
        refund_user_name: string // 负责人
        refund_prov_pic_list: string // 退款凭证图片集合，英文逗号拼接
    }[]
}

export default function () {

    const param: { id: string } = useParams()
    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<dataType[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)
    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/deal_refund_records', {
            params: {
                page,
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [page])

    return <div className="follow-record">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 退款记录 */}
        {data.map((el: dataType) =>
            <Fragment>
                <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>客户名称：{el.check_in_user_name}</Col>
                    <Col span={6}>客户手机号：{el.check_in_phone}</Col>
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>签单门店：{el.deal_store_name}</Col>
                    <Col span={6}>签单日期：{el.deal_date}</Col>
                    <Col span={6}>签单合同图片：<Button onClick={() => {
                        setUrls(el.deal_prov_pic_list.split(','))
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <Col span={6}>签单套餐：{el.deal_item_name}</Col>
                    <Col span={6}>入住天数：{el.item_days}</Col>
                    <Col span={6}>赠送天数：{el.gift_days}</Col>
                </Row>
                <Row style={{ marginBottom: 16 }}>
                    <Col span={24}>合同备注：{el.remark}</Col>
                </Row>

                <h5 style={{ fontSize: 18, marginBottom: 8 }}>退款记录</h5>
                <ul style={{ listStyle: 'none', marginTop: 8, paddingTop: 0 }}>
                    <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={el.refund_detail}>
                        <Column title="退款日期" dataIndex="refund_date" />
                        <Column title="退款金额" dataIndex="refund_amount" />
                        <Column title="退款凭证" dataIndex="refund_prov_pic_list" key="refund_prov_pic_list" render={(v: any) => {
                            return <Button onClick={() => {
                                setUrls(v.split(','))
                                setSiperVisible(true)
                            }} size="small" >查看</Button>
                        }} />
                        <Column title="退款原因" dataIndex="refund_reason" />

                        <Column title="录入人" dataIndex="refund_user_name" />
                        <Column title="审核结果" dataIndex="review_status" render={(v: number) => {
                            if (v === 0) return '待审核'
                            if (v === 1) return '审核通过'
                            if (v === 2) return '审核不通过'
                        }} />
                    </Table>
                </ul>
            </Fragment>)}

        {showLoadBtn && <Button onClick={() => {
            setPage(page + 1)
        }}>加载更多数据</Button>}

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
    </div>
}